/**
 * Get yat as a string and convert into an
 * array of 12 yats from the same
 * string to get a uniform Yat background
 * @param {Array} yat
 */
export function multiplyYat([...yat]: string) {
    const newYat = [...yat];

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < 14 - yat.length; i++) {
        newYat.push(yat[Math.floor(Math.random() * yat.length)]);
    }

    return newYat;
}

export const coordinates = [
    {
        left: '34vw',
        top: '-7vh',
        transform: 'rotate(50deg) scale(1.7)',
        filter: 'blur(2px)',
    },
    {
        left: '19vw',
        top: '24vh',
        transform: 'rotate(-15deg) scale(1.88)',
        filter: 'blur(0)',
    },
    {
        left: '-5vw',
        top: '73vh',
        transform: 'rotate(-30deg) scale(2.5)',
        filter: 'blur(3px)',
    },
    {
        left: '90vw',
        top: '3vh',
        transform: 'rotate(-10.4deg) scale(2, 2)',
        filter: 'blur(2.5px)',
    },
    {
        left: '71vw',
        top: '19vh',
        transform: 'rotate(26deg) scale(1.2, 1.2)',
        filter: 'blur(0)',
    },
    {
        right: '15vw',
        top: '43vh',
        transform: 'rotate(-11.2deg) scale(1.5)',
        filter: 'blur(0)',
    },
    {
        right: '15vw',
        top: '71vh',
        transform: 'rotate( -17.8deg) scale(2.4)',
        filter: 'blur(1.8px)',
    },
    { left: '13vw', top: '39vh', transform: 'scale(0.8)', filter: 'blur(1.8px)' },
    {
        left: '21vw',
        top: '64vh',
        transform: 'rotate(34.3deg) scale(1.9)',
        filter: 'blur(.33px)',
        zIndex: 4,
    },
    {
        left: '66vw',
        top: '82vh',
        transform: 'rotate(-167deg) scale(0.45)',
        filter: 'blur(0)',
    },
    {
        top: '60vh',
        right: '27vw',
        transform: 'rotate(7deg) scale(0.4, 0.4)',
        filter: 'blur(0)',
        zIndex: 2,
    },
    {
        top: '53vh',
        left: '19vw',
        transform: 'rotate(38deg) scale(0.6)',
        filter: 'blur(0)',
    },
    {
        top: '11vh',
        left: '8vw',
        transform: 'rotate(2.7deg) scale(0.8)',
        filter: 'blur(0)',
    },
    {
        bottom: '6vh',
        top: 'unset',
        left: '24vw',
        transform: 'rotate(36.7001deg) scale(0.6, 0.6)',
        filter: 'blur(0)',
    },
];

export const parallaxSpeeds = [
    0.038, 0.024, 0.022, 0.044, 0.0223, 0.046, 0.023, 0.042, 0.036, 0.022, 0.02, 0.021, 0.0356, 0.039,
];
